import { render, staticRenderFns } from "./SdkServer.vue?vue&type=template&id=d8109be0&scoped=true&"
import script from "./SdkServer.vue?vue&type=script&lang=js&"
export * from "./SdkServer.vue?vue&type=script&lang=js&"
import style0 from "./SdkServer.vue?vue&type=style&index=0&id=d8109be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8109be0",
  null
  
)

export default component.exports